'use strict';

import app from './ngmodule';

export enum VMScreenSize {
    mobile = "mobile",
    tablet = "tablet",
    desktop = "desktop",
    widescreen = "widescreen",
    fullhd = "fullhd"
}

export enum VMScreenOperation {
    resize = 1
}

export interface IVMScreenServiceListener {
    notify(operation: VMScreenOperation, service: IVMScreenService): void;
}

export interface IVMScreenService {
    register(listener: IVMScreenServiceListener): void;
    // de-registers a listener
    deRegister(listener: IVMScreenServiceListener): void;
    getCurrentSize(): VMScreenSize;

    readonly currentSize: VMScreenSize;

    isGreaterThan(sizeToTest: VMScreenSize | string, comparisonSize: VMScreenSize | string): boolean;
    isGreaterThanOrEqual(sizeToTest: VMScreenSize | string, comparisonSize: VMScreenSize | string): boolean;
    isLessThan(sizeToTest: VMScreenSize | string, comparisonSize: VMScreenSize | string): boolean;
    isLessThanOrEqual(sizeToTest: VMScreenSize | string, comparisonSize: VMScreenSize | string): boolean;

    isBetween(lowSizeToTest: VMScreenSize | string, highSizeToTest: VMScreenSize | string, comparisonSize: VMScreenSize | string): boolean;
    isOneOf(sizesToTest : Array<VMScreenSize | string>, comparisonSize: VMScreenSize | string): boolean;
}

export class vmScreenService implements IVMScreenService {
    private listeners: Array<IVMScreenServiceListener>;
    private currentScreenSize: VMScreenSize;

    private sizesByNumber: any = {
        mobile: 1,
        tablet: 2,
        desktop: 3,
        widescreen: 4,
        fullhd: 5
    }

    static $inject = ['$timeout', '$window'];
    constructor(protected $timeout: ng.ITimeoutService, protected $window: ng.IWindowService) {
        this.listeners = [];

        this.currentScreenSize = this.getCurrentSize();

        $(this.$window).on('resize', () => {
            this.$timeout(() => {
                this.currentScreenSize = this.getCurrentSize();
                this.notifyListeners(VMScreenOperation.resize);
            });            
        });
    }

    public get currentSize(): VMScreenSize {
        return this.currentScreenSize;
    }

    private notifyListeners(operation: VMScreenOperation): void {
        for(let l of this.listeners)
        {
            l.notify(operation, this);
        }
    }

    public isGreaterThan(sizeToTest: VMScreenSize | string, comparisonSize: VMScreenSize | string): boolean {
        let s : number = this.sizesByNumber[sizeToTest.toString()];
        let c : number = this.sizesByNumber[comparisonSize.toString()];

        return s > c;
    }

    public isGreaterThanOrEqual(sizeToTest: VMScreenSize | string, comparisonSize: VMScreenSize | string): boolean {
        let s : number = this.sizesByNumber[sizeToTest.toString()];
        let c : number = this.sizesByNumber[comparisonSize.toString()];

        return s >= c;
    }

    public isLessThan(sizeToTest: VMScreenSize | string, comparisonSize: VMScreenSize | string): boolean {
        let s : number = this.sizesByNumber[sizeToTest.toString()];
        let c : number = this.sizesByNumber[comparisonSize.toString()];

        return s < c;
    }

    public isLessThanOrEqual(sizeToTest: VMScreenSize | string, comparisonSize: VMScreenSize | string): boolean {
        let s : number = this.sizesByNumber[sizeToTest.toString()];
        let c : number = this.sizesByNumber[comparisonSize.toString()];

        return s <= c;
    }    

    isBetween(lowSizeToTest: VMScreenSize | string, highSizeToTest: VMScreenSize | string, comparisonSize: VMScreenSize | string, useEquals: boolean = true): boolean {
        let l : number = this.sizesByNumber[lowSizeToTest.toString()];
        let h : number = this.sizesByNumber[highSizeToTest.toString()];
        let c : number = this.sizesByNumber[comparisonSize.toString()];

        return useEquals ? c >= l && c <= h : c > l && c < h;
    }

    isOneOf(sizesToTest : Array<VMScreenSize | string>, comparisonSize: VMScreenSize | string): boolean {
        let c : number = this.sizesByNumber[comparisonSize.toString()];

        for(let size of sizesToTest)
        {
            let s : number = this.sizesByNumber[size.toString()];
            
            if(s == c)
            {
                return true;                
            }
        }

        return false;
    }

    public getCurrentSize(): VMScreenSize {
        let size = this.$window.innerWidth;

        if(size <= 768)
        {
            return VMScreenSize.mobile;            
        }
        else if(size >= 769 && size <= 1023)
        {
            return VMScreenSize.tablet;            
        }
        else if(size >= 1024 && size <= 1215)
        {
            return VMScreenSize.desktop;
        }
        else if(size >= 1216 && size <= 1407)
        {
            return VMScreenSize.widescreen;
        }
        else
        {
            return VMScreenSize.fullhd;
        }
    }

    public register(listener: IVMScreenServiceListener) {
        // can't register the same object more than once
        if(this.listeners.indexOf(listener) >= 0)
        {
            return;
        }

        this.listeners.push(listener);
    }

    public deRegister(listener: IVMScreenServiceListener) {
        this.listeners = this.listeners.filter(l => l !== listener);
    }
}

app.factory('vmScreenService', vmScreenService);